import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const IdIslaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [islas, setIslas] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.ISLAGRIFO, {}, true).then(({ data }) => {
      setIslas(data)
    })
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='ISLA' htmlFor='select-idIsla' md={4} alignRightAt='md' />
        <Col md={8}>
          <Field name='idIsla'>
            {({ field }) => (
              <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idIsla'>
                <option key='seleccionar' value=''>
                  Seleccionar
                </option>
                {islas.map(x => (
                  <option key={x._id} value={x._id}>
                    {x.nombre}
                  </option>
                ))}
              </Form.Select>
            )}
          </Field>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(IdIslaFormGroup)
